import React from "react";

import { Link } from "react-router-dom";

import PrintIcon from "../../icons/print-icon";

const MainPrintLink = ({ path, icon, title= "چاپ"}) => {
  return (
    <Link to={`/print/${path}`} target="_blank">
      <button className={`circle print`} title={title}>
        {icon ? icon : <PrintIcon />}
      </button>
    </Link>
  );
};

export default MainPrintLink;
